'use client'
import { FC, useState } from 'react'
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from '@prismicio/react'
import { PrismicNextImage } from '@prismicio/next'
import CloseIcon from '@/assets/images/icons/icon-team-close.svg'

export type TeamProps = SliceComponentProps<Content.TeamSlice>;

const Team: FC<TeamProps> = ({ slice }) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="px-4 md:px-8 lg:px-12 2xl:px-0 font-fellix mb-12"
    >
      <div className="max-w-[1280px] mx-auto">
        {slice.primary.team_title && (
          <article className="text-[28px] leading-[36px] pb-8 font-semibold">
            <PrismicRichText field={slice.primary.team_title} />
          </article>
        )}
        <div className="grid grid-cols-12 gap-0 md:gap-6">
          {slice.primary.team.map((item: any, index: number) => (
            <div className="col-span-12 md:col-span-6 lg:col-span-4 relative" key={index}>
              <div onClick={() => setSelectedIndex(index)} className="cursor-pointer">
                <PrismicNextImage field={item.image} fallbackAlt="" className="w-full object-cover aspect-5/4 mb-4" />
                <p className="text-lg leading-[26px] font-normal">{item.name}</p>
                <p className="text-lg leading-[26px] font-normal text-black/50 mb-4">{item.job_title}</p>
              </div>

              {selectedIndex === index && (
                <div className="bio block">
                  <div className="bio-contact">
                    {item.phone?.url && (
                      <p><span>T:</span><a href={`tel:${item.phone.url}`}>{item.phone.url.replace("tel:", "")}</a></p>
                    )}
                    {item.mobile?.url && (
                      <p><span>M:</span><a href={`tel:${item.mobile.url}`}>{item.mobile.url.replace("tel:", "")}</a></p>
                    )}
                    {item.email?.url && (
                      <p><span>E:</span><a href={`mailto:${item.email.url}`}>{item.email.url.replace("mailto:", "")}</a></p>
                    )}
                  </div>
                  {item.bio && (
                    <div className="bio-text"><PrismicRichText field={item.bio} /></div>
                  )}
                  <div className="w-full text-right relative cursor-pointer pb-12" onClick={() => setSelectedIndex(null)}>
                    <CloseIcon className="absolute right-0" />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
